import { Component, OnInit, Input } from '@angular/core';
import { NavigationService } from '../../../../modules/tcm-core.module';

@Component({
    selector: 'tcm-video-player',
    templateUrl: './tcm-video-player.component.html',
    styleUrls: ['./tcm-video-player.component.scss'],
    standalone: false
})
export class TcmVideoPlayerComponent {

  @Input() link: string;
  @Input() autoplay: boolean = true;

  isLoading: boolean;

  constructor(private navSvc: NavigationService) { }

  back() {
    this.navSvc.navigateBack();
  }
}
